import { AttractionsList } from '@/components/attractions';
import { attractionCrudConfig, type Attraction } from '@/config/objects/attractions';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function GreaterAreaAttractionsTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const config: CrudConfig<Attraction> = useMemo(
    () => ({
      ...attractionCrudConfig,
      entityName: 'Attraction',
      entityNamePlural: 'Attractions',
      endpoints: {
        ...attractionCrudConfig.endpoints,
        list: `/greater-areas/${id}/attractions`,
        delete: (attractionId: string) => `/greater-areas/${id}/attractions/${attractionId}`,
      },
      listView: {
        ...attractionCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/attractions',
            where: {
              greaterAreaId: {
                not: id,
              },
            },
            onAdd: async (attraction: Attraction) => {
              await apiClient.post(`/greater-areas/${id}/attractions`, {
                attractionId: attraction.id,
              });
              toast.success('Attraction added to greater area');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (attraction: Attraction) => {
              await apiClient.delete(`/greater-areas/${id}/attractions/${attraction.id}`);
              toast.success('Attraction removed from greater area');
            },
          },
        },
      },
    }),
    [id, apiClient],
  );

  if (!id) return null;

  return <AttractionsList config={config} className="p-0" baseUrl="/attractions" />;
}
